// The id type is required though the more logical is number
export const FORM_NEW_ITEM_ID = '0';

// Mapping between the owner status as return in address form
// and the url path to access the same form
export const ADDRESS_OWNER_STATUS_TO_FORM = {
  artist: 'artists',
  interm: 'sellers',
  collec: 'collectors',
  autres: 'others',
};
